import { N15_01 } from "./N15_01";

export const N15 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "bar",
        "colorTheme": 'colorTheme2',
        "title": "RECOVERED CALLS",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Count',
                        "value": 'TotalCount',
                        "type": 'column'

                    }
                ],
                "title": 'SubCycle',
                "endpoint": "SFE_N15",
                "parameters": [
                    { "key": "CycleCode", "value": "1" },
                    { "key": "CycleYear", "value": "2025" },
                ]
            },
            "context": {
                "point": {
                    "onClick": N15_01
                }
            }
        }
    }
}